import React from 'react';

import { Hotkey } from 'ui-components/components/hotkey';

import { useUserSettingAdvancedHotkeys } from './hooks';

/**
 * @typedef {object} HotkeyConfig
 * @property {string[]} [displayHotkeyStrings]
 * @property {string} [barcode]
 * @property {(string | { key?: string, hasCtrlEquivalent?: boolean, hasModifier?: boolean })[]} [hotkey]
 * @property {() => void} [handler]
 * @property {string} [name]
 * @property {'general' | 'navigation' | 'printing' | 'shipping'} [legacyCategory]
 * @property {boolean} [doNotTrack]
 * @property {(bufferString: string, buffer: unknown[]) => boolean} [matches]
 * @property {boolean} [isGlobal]
 * @property {boolean} [doNotClearBufferOnCompleteMatch]
 * @property {string[]} [partialMatch]
 * @property {boolean} [isCustomPreset]
 * @property {string} [presetName]
 */

/**
 * @param {object} props
 * @param {import('react').ReactNode} [props.children]
 * @param {HotkeyConfig} props.hotkey
 */
export const AdvancedHotkey = ({ children = null, hotkey }) => {
  const { areAdvancedHotkeysEnabled } = useUserSettingAdvancedHotkeys();

  const hotkeyToUse = !areAdvancedHotkeysEnabled ? undefined : hotkey;

  return <Hotkey hotkey={hotkeyToUse}>{children}</Hotkey>;
};
